import styled from 'styled-components';
import { customMedia } from 'styles/utils';

export const MaxWidthWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: ${props => props.theme.layout.maxWidth};
`;

export const DefaultSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100vw;
  height: ${props => (props.fullScreen ? '100vh' : 'auto')};
  padding: ${props => props.theme.spacing.large};
  overflow: hidden;

  ${props =>
    props.fullScreen &&
    `
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    background-color: ${props.theme.color.wfWhite};
  `}

  ${customMedia.lessThan('large')`
    padding: 5rem ${props => props.theme.spacing.default};
  `};
  ${customMedia.lessThan('medium')`
    padding: 4rem ${props => props.theme.spacing.medium};
  `};
  ${customMedia.lessThan('small')`
    padding: 3rem ${props => props.theme.spacing.small};
  `};
`;

export const DefaultWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100%;
  max-width: ${props => props.theme.layout.maxWidth};
  padding: ${props => props.theme.spacing.large};

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }

  ${customMedia.lessThan('large')`
    padding: ${props => props.theme.spacing.default};
  `};
  ${customMedia.lessThan('medium')`
    padding: ${props => props.theme.spacing.medium};
  `};
  ${customMedia.lessThan('small')`
    padding: ${props => props.theme.spacing.small};
  `};
`;

export const DefaultModalWrapper = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 26rem;
  width: ${props => (props.small ? '40%' : '70%')};
  max-width: ${props => props.theme.layout.maxWidth};
  min-height: calc(100vh - (2 * ${props => props.theme.spacing.xlarge}));
  background-color: ${props => props.theme.color.wfWhite};
  margin: ${props => props.theme.spacing.xlarge} auto;
  overflow-y: auto;

  ${customMedia.lessThan('medium')`
    width: 92vw;
  `};
`;
